<template lang="html">
  <section class="guide">

    <div style="width: 100%">

      <description />
      <setup />
      <login />
      <usage />
      <sip-support />
      <push-notification />

    </div>

  </section>

</template>

<script lang="js">
  import {
  } from "@vonagevolta/vue";

  import Description from './sections/description';
  import Setup from './sections/setup/setup';
  import Login from './sections/login/loginPage';
  import Usage from './sections/usage/usage';
  import SipSupport from './sections/sip';
  import PushNotification from './sections/pushNotification';

  export default  {
    name: 'guide',
    components: {
      "description": Description,
      "setup": Setup,
      "login": Login,
      "usage": Usage,
      "sip-support": SipSupport,
      "push-notification": PushNotification,
    },
    props: {
      nexmo:{
          type: Object,
          required: false
      }
    },
}
</script>

<style scoped lang="scss">
</style>